<template>
	<b-row>
		<b-col cols="12">
			<div id="parentx">
				<transition name="slide">
					<b-card>
						<div slot="header">
							{{ $t('promo-to-product.promos') }}
						</div>
						<b-card-body>
							<b-tabs>
								<b-tab :title="$t('promo-to-product.simple-discount')" active>
									<b-link @click="newPromo(null, 'create')"
										class="card-header-action btn-setting float-right pr-2" style="font-size: 15px"
										v-if="$can('create/update', 'promotion')">
										<i class="fa fa-plus-circle"></i>
									</b-link>
									<div class="table-responsive table-wrapper">
										<b-table striped hover :items="items" :fields="refField"
											:current-page="search.limit" :per-page="0" bordered="bordered" show-empty
											class="generalTableClass">
											<template slot="empty" slot-scope="scope">
												<h6>{{ $t('empty') }}</h6>
											</template>
											<template slot="id" slot-scope="data">
												{{ data.index + 1 }}
											</template>
											<template slot="start" slot-scope="data" class="col-md-8">
												{{ data.item.start }}
											</template>

											<template slot="finish" slot-scope="data" class="col-md-8">
												{{ data.item.finish }}
											</template>
											<template slot="departments" slot-scope="data" class="col-md-8">
												<span v-for="dep in data.item.departmentsList" :key="dep.id"
													class="pr-2">
													{{ dep.name }},
												</span>
											</template>

											<template slot="status" slot-scope="data" class="col-md-8">
												<b-badge variant="success" v-if="data.item.status === 'ACTIVE'">{{
													data.item.status
												}}
												</b-badge>
												<b-badge variant="warning" v-else-if="data.item.status === 'PENDING'">{{
													data.item.status
												}}
												</b-badge>
												<b-badge variant="danger" v-else-if="data.item.status === 'REJECTED'">{{
													data.item.status
												}}
												</b-badge>
												<b-badge variant="info" v-else-if="data.item.status === 'INACTIVE'">{{
													data.item.status
												}}
												</b-badge>
											</template>

											<template slot="actions" slot-scope="data">
												<b-link @click="openCreate(data.item, 'edit')" :title="$t('Edit')"
													v-if="$can('edit', 'promotion')">
													<i class="fa fa-edit"></i>
												</b-link>
												<b-link :key="data.item.id + 'delete'"
													@click="closeOthers(data.item.id)"
													:id="'popOverDelete' + data.item.id"
													v-if="$can('delete', 'promotion')">
													<i class="fa fa-trash"></i>
												</b-link>
												<b-link
													@click="openBarcodeModal(data.item, data.item.departmentsList, data.item.discount, data.item.promotionType)">
													<i class="fa fa-barcode"></i>
												</b-link>
												<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
												<b-popover :key="data.item.id + 'popover'"
													:target="'popOverDelete' + data.item.id" placement="auto"
													container="myContainer" :ref="'popover' + data.item.id"
													class="refDeleteConfirm">
													<template slot="title">
														<b-button @click="onClose(data.item.id)" class="close"
															aria-label="Close" style="margin-left: 5px">
															<span class="d-inline-block"
																aria-hidden="true">&times;</span>
														</b-button>
														{{ $t('actions.deletetitle') }}
													</template>

													<div>
														<!--<b-link @click="onClose" size="sm" variant="danger">Yo'q</b-link>
                                                        <b-link @click="onOk" size="sm" variant="primary">Ha</b-link>-->
														<div class="row mt-1">
															<div class="col-6">
																<b-button variant="outline-danger" size="sm" block
																	@click="deletePopover(data.item.id)">
																	{{ $t('actions.no') }}
																</b-button>
															</div>
															<div class="col-6">
																<b-button variant="outline-success" size="sm" block
																	@click="remove(data.item.id)">
																	{{ $t('actions.yes') }}
																</b-button>
															</div>
														</div>
													</div>
												</b-popover>
												<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->

											</template>

										</b-table>
										<div v-if="loader" class="spinner-wrapper">
											<b-spinner></b-spinner>
										</div>
									</div>
									<!-- TABLE -->
									<!-- TABLE -->
									<nav>
										<b-pagination :total-rows="total" :per-page="search.limit" v-model="search.page"
											:prev-text="$t('pagination.prev')" :next-text="$t('pagination.next')"
											hide-goto-end-buttons />
									</nav>
									<div class="clearfix"></div>
								</b-tab>
								<b-tab :title="$t('promo-to-product.buy-x-get-y')" @click="buyXGetYPromos('BuyXGetY')">

									<b-link @click="secondNewPromo(null, 'create')"
										class="card-header-action btn-setting float-right pr-2" style="font-size: 15px"
										v-if="$can('create/update', 'promotion')">
										<i class="fa fa-plus-circle"></i>
									</b-link>
									<div class="table-responsive table-wrapper">
										<b-table striped hover :items="secondItems" :fields="secondRefField"
											:current-page="secondSearch.limit" :per-page="0" bordered="bordered"
											show-empty class="generalTableClass">
											<template slot="empty" slot-scope="scope">
												<h6>{{ $t('empty') }}</h6>
											</template>
											<template slot="id" slot-scope="data">
												{{ data.index + 1 }}
											</template>

											<template slot="start" slot-scope="data" class="col-md-8">
												{{ data.item.start }}
											</template>

											<template slot="finish" slot-scope="data" class="col-md-8">
												{{ data.item.finish }}
											</template>

											<template slot="departments" slot-scope="data" class="col-md-8">
												<span v-for="dep in data.item.departmentsList" :key="dep.id"
													class="pr-2">
													{{ dep.name }},
												</span>
											</template>

											<template slot="status" slot-scope="data" class="col-md-8">
												<b-badge variant="success" v-if="data.item.status === 'ACTIVE'">{{
													data.item.status
												}}
												</b-badge>
												<b-badge variant="warning" v-else-if="data.item.status === 'PENDING'">{{
													data.item.status
												}}
												</b-badge>
												<b-badge variant="danger" v-else-if="data.item.status === 'REJECTED'">{{
													data.item.status
												}}
												</b-badge>
												<b-badge variant="info" v-else-if="data.item.status === 'INACTIVE'">{{
													data.item.status
												}}
												</b-badge>
											</template>

											<template slot="actions" slot-scope="data">
												<b-link @click="secondOpenCreate(data.item, 'edit')" :title="$t('Edit')"
													v-if="$can('edit', 'promotion')">
													<i class="fa fa-edit"></i>
												</b-link>
												<b-link :key="data.item.id + 'delete'"
													@click="closeOthers(data.item.id)"
													:id="'popOverDelete' + data.item.id"
													v-if="$can('delete', 'promotion')">
													<i class="fa fa-trash"></i>
												</b-link>
												<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
												<b-popover :key="data.item.id + 'popover'"
													:target="'popOverDelete' + data.item.id" placement="auto"
													container="myContainer" :ref="'popover' + data.item.id"
													class="refDeleteConfirm">
													<template slot="title">
														<b-button @click="onClose(data.item.id)" class="close"
															aria-label="Close" style="margin-left: 5px">
															<span class="d-inline-block"
																aria-hidden="true">&times;</span>
														</b-button>
														{{ $t('actions.deletetitle') }}
													</template>

													<div>
														<!--<b-link @click="onClose" size="sm" variant="danger">Yo'q</b-link>
                                                        <b-link @click="onOk" size="sm" variant="primary">Ha</b-link>-->
														<div class="row mt-1">
															<div class="col-6">
																<b-button variant="outline-danger" size="sm" block
																	@click="deletePopover(data.item.id)">
																	{{ $t('actions.no') }}
																</b-button>
															</div>
															<div class="col-6">
																<b-button variant="outline-success" size="sm" block
																	@click="removeBuyX(data.item.id)">
																	{{ $t('actions.yes') }}
																</b-button>
															</div>
														</div>
													</div>
												</b-popover>
												<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->

											</template>

										</b-table>
										<div v-if="loader" class="spinner-wrapper">
											<b-spinner></b-spinner>
										</div>
									</div>
									<!-- TABLE -->
									<!-- TABLE -->
									<nav>
										<b-pagination :total-rows="secondTotal" :per-page="secondSearch.limit"
											v-model="secondSearch.page" :prev-text="$t('pagination.prev')"
											:next-text="$t('pagination.next')" hide-goto-end-buttons />
									</nav>
								</b-tab>
								<b-tab :title="$t('promo-to-product.one-time-discount')"
									@click="getOneTimeDiscountDocs()">
									<b-link @click="newPromoTab(null, 'create')"
										class="card-header-action btn-setting float-right pr-2" style="font-size: 15px"
										v-if="$can('create/update', 'promotion')">
										<i class="fa fa-plus-circle"></i>
									</b-link>
									<div class="table-responsive table-wrapper">
										<b-table striped hover :items="oneTimeDiscountDocs" :fields="headers"
											:current-page="thirdSearch.limit" :per-page="0" bordered="bordered"
											show-empty class="generalTableClass">
											<template slot="empty" slot-scope="scope">
												<h6>{{ $t('empty') }}</h6>
											</template>
											<template slot="id" slot-scope="data">
												{{ paginate(data.index, thirdSearch.page, thirdSearch.limit) }}
											</template>

											<template slot="start" slot-scope="data" class="col-md-8">
												{{ data.item.startDate }}
											</template>

											<template slot="finish" slot-scope="data" class="col-md-8">
												{{ data.item.finishDate }}
											</template>

											<template slot="departments" slot-scope="data" class="col-md-8">
												{{ data.item.toDepartmentName }}
											</template>

											<template slot="actions" slot-scope="data">

												<b-link @click="openCreateTab(data.item, 'edit')" :title="$t('Edit')"
													v-if="data.item.documentStatus == 'SUSPENDED'">
													<i class="fa fa-edit">{{ data.toDepartmentName }}</i>
												</b-link>
												<b-link @click="openCreateTab(data.item, 'view')" :title="$t('Edit')"
													v-if="data.item.documentStatus == 'READY'">
													<i class="fa fa-eye" />
												</b-link>

												<b-link :key="data.item.id + 'delete'"
													@click="closeOthers(data.item.id)"
													:id="'popOverDelete' + data.item.id"
													v-if="$can('delete', 'promotion') && data.item.documentStatus == 'SUSPENDED'">
													<i class="fa fa-trash"></i>
												</b-link>
												<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
												<b-popover :key="data.item.id + 'popover'"
													:target="'popOverDelete' + data.item.id" placement="auto"
													container="myContainer" :ref="'popover' + data.item.id"
													class="refDeleteConfirm">
													<template slot="title">
														<b-button @click="onClose(data.item.id)" class="close"
															aria-label="Close" style="margin-left: 5px">
															<span class="d-inline-block"
																aria-hidden="true">&times;</span>
														</b-button>
														{{ $t('actions.deletetitle') }}
													</template>

													<div>
														<!--<b-link @click="onClose" size="sm" variant="danger">Yo'q</b-link>
                                                        <b-link @click="onOk" size="sm" variant="primary">Ha</b-link>-->
														<div class="row mt-1">
															<div class="col-6">
																<b-button variant="outline-danger" size="sm" block
																	@click="deletePopover(data.item.id)">
																	{{ $t('actions.no') }}
																</b-button>
															</div>
															<div class="col-6">
																<b-button variant="outline-success" size="sm" block
																	@click="removeTab(data.item.id)">
																	{{ $t('actions.yes') }}
																</b-button>
															</div>
														</div>
													</div>
												</b-popover>
												<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->

											</template>

										</b-table>
										<div v-if="loader" class="spinner-wrapper">
											<b-spinner></b-spinner>
										</div>
									</div>
									<!-- TABLE -->
									<!-- TABLE -->
									<nav>
										<b-pagination :total-rows="oneTimeDiscountDocsTotal"
											:per-page="thirdSearch.limit" v-model="thirdSearch.page"
											:prev-text="$t('pagination.prev')" :next-text="$t('pagination.next')"
											hide-goto-end-buttons />
									</nav>
									<div class="clearfix"></div>
								</b-tab>
								<b-tab :title="$t('Новая скидка')" @click="getAddPromotoion()">
									<b-link @click="promotionAdd(null, 'create')"
										class="card-header-action btn-setting float-right pr-2" style="font-size: 15px"
										v-if="$can('create/update', 'promotion')">
										<i class="fa fa-plus-circle"></i>
									</b-link>
									<div class="table-responsive table-wrapper">
										<b-table striped hover :items="promotionSimpleItems" :fields="refField"
											:current-page="promotionSimpleSearch.limit" :per-page="0" bordered="bordered"
											show-empty class="generalTableClass">
											<template slot="empty" slot-scope="scope">
												<h6>{{ $t('empty') }}</h6>
											</template>
											<template slot="id" slot-scope="data">
												{{ data.index + 1 }}
											</template>
											<template slot="start" slot-scope="data" class="col-md-8">
												{{ data.item.start }}
											</template>

											<template slot="finish" slot-scope="data" class="col-md-8">
												{{ data.item.finish }}
											</template>
											<template slot="departments" slot-scope="data" class="col-md-8">
												<span v-for="dep in data.item.departmentsList" :key="dep.id"
													class="pr-2">
													{{ dep.name }},
												</span>
											</template>

											<template slot="status" slot-scope="data" class="col-md-8">
												<b-badge variant="success" v-if="data.item.status === 'ACTIVE'">{{
													data.item.status
												}}
												</b-badge>
												<b-badge variant="warning" v-else-if="data.item.status === 'PENDING'">{{
													data.item.status
												}}
												</b-badge>
												<b-badge variant="danger" v-else-if="data.item.status === 'REJECTED'">{{
													data.item.status
												}}
												</b-badge>
												<b-badge variant="info" v-else-if="data.item.status === 'INACTIVE'">{{
													data.item.status
												}}
												</b-badge>
											</template>

											<template slot="actions" slot-scope="data">
												<!-- <b-link @click="openCreate(data.item, 'edit')" :title="$t('Edit')"
													v-if="$can('edit', 'promotion')">
													<i class="fa fa-edit"></i>
												</b-link> -->
												<b-link @click="promotionAdd(data.item, 'view')" :title="$t('Edit')">
													<i class="fa fa-eye" />
												</b-link>
												<!-- <b-link
													@click="openBarcodeModal(data.item, data.item.departmentsList, data.item.discount, data.item.promotionType)">
													<i class="fa fa-barcode"></i>
												</b-link> -->
												<b-link :key="data.item.id + 'delete'"
													@click="closeOthers(data.item.id)"
													:id="'popOverDeletee' + data.item.id"
													v-if="$can('delete', 'promotion')">
													<i class="fa fa-trash"></i>
												</b-link>
												<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
												<b-popover :key="data.item.id + 'popover'"
													:target="'popOverDeletee' + data.item.id" placement="auto"
													container="myContainer" :ref="'popover' + data.item.id"
													class="refDeleteConfirm">
													<template slot="title">
														<b-button @click="onClose(data.item.id)" class="close"
															aria-label="Close" style="margin-left: 5px">
															<span class="d-inline-block"
																aria-hidden="true">&times;</span>
														</b-button>
														{{ $t('actions.deletetitle') }}
													</template>

													<div>
														<!--<b-link @click="onClose" size="sm" variant="danger">Yo'q</b-link>
                                                        <b-link @click="onOk" size="sm" variant="primary">Ha</b-link>-->
														<div class="row mt-1">
															<div class="col-6">
																<b-button variant="outline-danger" size="sm" block
																	@click="deletePopover(data.item.id)">
																	{{ $t('actions.no') }}
																</b-button>
															</div>
															<div class="col-6">
																<b-button variant="outline-success" size="sm" block
																	@click="removePromotionSimple(data.item.id)">
																	{{ $t('actions.yes') }}
																</b-button>
															</div>
														</div>
													</div>
												</b-popover>
												<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->

											</template>

										</b-table>
										<div v-if="loader" class="spinner-wrapper">
											<b-spinner></b-spinner>
										</div>
									</div>
									<!-- TABLE -->
									<!-- TABLE -->
									<nav>
										<b-pagination :total-rows="promotionSimpleTotal"
											:per-page="promotionSimpleSearch.limit" v-model="promotionSimpleSearch.page"
											:prev-text="$t('pagination.prev')" :next-text="$t('pagination.next')"
											hide-goto-end-buttons />
									</nav>
									<div class="clearfix"></div>
								</b-tab>
							</b-tabs>
						</b-card-body>
					</b-card>
				</transition>
				<vs-sidebar :click-not-close="true" position-right parent="body" default-index="1" color="primary"
					class="create-modal-promotion" spacer v-model="addPromo">
					<b-container index="1" v-if="addPromo" class="promotion">
						<new-promo @success="reloadList()" @not-close="closable = $event" @close="close" :mode="mode"
							:edit="item" :totalForEdit="totalForEdit"></new-promo>
					</b-container>
				</vs-sidebar>

				<vs-sidebar :click-not-close="true" position-right parent="body" default-index="1" color="primary"
					class="create-modal-promotion" spacer v-model="promotionAddModal">
					<b-container index="1" v-if="promotionAddModal" class="promotion">
						<promotion-simple @success="reloadPromotionSimpleList()" @not-close="closable = $event"
							@close="closePromotionSimple" :mode="mode" :edit="item"
							:totalForEdit="totalForEdit"></promotion-simple>
					</b-container>
				</vs-sidebar>

				<vs-sidebar :click-not-close="true" position-right parent="body" default-index="1" color="primary"
					class="create-modal-promotion" spacer v-model="addSecondPromo">
					<b-container index="1" v-if="addSecondPromo" class="promotion">
						<second-new-promo @success="secondReloadList()" @not-close="closable = $event"
							@close="buyXgetYClose" :mode="buyXgetYMode" :edit="secondItem"
							:secondTotalForEdit="secondTotalForEditGet"
							:totalForEdit="secondTotalForEdit"></second-new-promo>
					</b-container>
				</vs-sidebar>

				<vs-sidebar :click-not-close="true" position-right parent="body" default-index="1" color="primary"
					class="create-modal-promotion" spacer v-model="addThirdPromo">
					<b-container index="1" v-if="addThirdPromo" class="promotion">
						<one-time-discount-tabs @success="reloadListTab()" @not-close="closable = $event"
							@close="closeTab" :mode="modeTab" :edit="oneTimeDiscountDoc" :view="isView"
							:totalForEdit="thirdTotalForEdit"></one-time-discount-tabs>
					</b-container>
				</vs-sidebar>

				<!-- barcode modal -->
				<b-modal v-model="isOpenBarcodeModal" size="lg" @close="headerclose" hide-footer>
					<barcode-generate ref="barcodeGenerate" @closeModal="closeModal">
					</barcode-generate>

				</b-modal>

			</div>
		</b-col>
	</b-row>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex'
import NewPromo from './blocks/NewPromo'
import PromotionSimple from './blocks/PromotionSimple'
import SecondNewPromo from './blocks/SecondNewPromo'
import PromoService from "../../../services/promo.service";
import BarcodeGenerate from "./blocks/BarcodeModal"
import NewPromoTabs from "./blocks/OneTimeDiscountTabs";
import OneTimeDiscountTabs from "@/views/point-of-sale/promo-to-product/blocks/OneTimeDiscountTabs";


export default {
	name: 'PromoToProduct',
	/**
	 *
	 */
	props: {

		/**
		 *  Card caption
		 */
		caption: {
			type: String,
			default: 'Promos'
		}
	},

	data: () => {
		return {
			itemsForBarcode: {},
			isOpenBarcodeModal: false,
			loader: true,
			refField: [],
			secondRefField: [],
			items: [],
			oneTimeDiscountDocs: [],
			oneTimeDiscountDoc: null,
			isView: false,
			oneTimeDiscountDocsTotal: 0,
			total: 0,
			secondItems: [],
			secondTotal: 0,
			promotionSimpleItems: [],
			promotionSimpleTotal: 0,
			mode: 'create',
			buyXgetYMode: 'create',
			modeTab: 'create',
			addPromo: false,
			promotionAddModal: false,
			addSecondPromo: false,
			addThirdPromo: false,
			testArray: [],
			item: null,
			secondItem: null,
			closable: false,
			oneTimeDiscountDocsId: null,
			search: {
				page: 1,
				limit: 20,
				attributes: []
			},
			secondSearch: {
				page: 1,
				limit: 20,
				attributes: []
			},
			thirdSearch: {
				page: 1,
				limit: 20,
				attributes: []
			},
			promotionSimpleSearch: {
				page: 1,
				limit: 20,
				attributes: []
			},
			totalForEdit: 0,
			secondTotalForEdit: 0,
			thirdTotalForEdit: 0,
			secondTotalForEditGet: 0,
			headers: [
				{
					key: 'actions',
					label: 'Действие',
					'class': 'min-60',
					visible: true,
					changebale: false
				},
				{
					key: 'id',
					label: '№',
					class: 'text-center',
					sortable: true,
					visible: true,
					changebale: false
				},
				{
					key: 'regNumber',
					label: 'Регистрационный но',
					'class': 'td-20',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'regDate',
					label: 'Дата',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'docCreatedBy',
					label: 'Создатель',
					visible: false,
					'class': 'min-100',
					sortable: true,
					changebale: true
				},
				{
					key: 'docCreatedDate',
					label: 'Дата создания',
					visible: false,
					'class': 'text-center',
					sortable: true,
					changebale: true
				},
				{
					key: 'docLastModifiedBy',
					label: 'Обнoвлён',
					visible: false,
					'class': 'min-100',
					sortable: true,
					changebale: true
				},
				{
					key: 'docChangedDate',
					label: 'Дата обновления',
					visible: false,
					'class': 'text-center',
					sortable: true,
					changebale: true
				},
				{
					key: 'startDiscountDate',
					label: 'От',
					'class': 'td-20',
					sortable: true,
					visible: true,
					changebale: true,
				},
				{
					key: 'endDiscountDate',
					label: 'До',
					'class': 'td-20',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'toDepartmentName',
					label: 'Отдел',
					'class': 'td-26',
					sortable: false,
					visible: true,
					changebale: true
				}
			],
		};
	},
	/**
	 * Computed
	 */
	computed: {
		...mapGetters('promo', [
			'columns'
		]),
	},

	mounted() {
		setTimeout(() => {
			this.loader = true;
		})
		this.getAllPromos();
		this.refField = this.filterColumns(this.columns)
		this.loader = false;
	},
	methods: {
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		headerclose() {
			this.$refs.barcodeGenerate.closeModal()
		},
		closeModal() {
			this.isOpenBarcodeModal = false;
		},
		async openBarcodeModal(item, departments, discount, promoType) {
			await this.$store.commit('promo/setDepartmentsForBarcode',
				{
					id: item.id, departments: departments,
					discount: discount, promoType: promoType
				});
			this.isOpenBarcodeModal = true
		},
		getAllPromos() {
			this.loader = true;
			PromoService.getAllPromos(this.search).then(response => {
				this.items = response.data.items;
				this.total = response.data.total;
				this.loader = false;
			}).catch(() => {
				this.loader = true;
			});
		},
		getAllPromosTab() {
			this.loader = true;
			PromoService.createOneTimeDiscountDoc({ action: 'DISCOUNT', documentType: 'ONE_TIME' }).then(response => {
				this.oneTimeDiscountDocs = response.data;

			}).catch(() => {
				this.loader = true;
			});
		},
		buyXGetYPromos(section) {
			this.loader = true;
			PromoService.buyXGetYPromos(this.secondSearch).then(response => {
				this.secondItems = response.data.items;
				this.secondTotal = response.data.total;
				this.loader = false
			}).catch(() => {
				this.loader = true;
			});
			this.secondRefField = this.columns.filter((column => {
				if (column.key !== 'discount' && column.visible) {
					column.label = this.$t(column.label)
					return column
				}
			}))
		},
		getAddPromotoion() {
			this.loader = true;
			PromoService.listSimple(this.promotionSimpleSearch).then(response => {
				this.promotionSimpleItems = response.data.items;
				this.promotionSimpleTotal = response.data.total;
				this.loader = false
			}).catch(() => {
				this.loader = true;
			});
			this.secondRefField = this.columns.filter((column => {
				if (column.key !== 'discount' && column.visible) {
					column.label = this.$t(column.label)
					return column
				}
			}))
		},
		getOneTimeDiscountDocs() {
			this.loader = true;
			PromoService.getOneTimeDiscountDocs(this.thirdSearch).then(response => {
				this.oneTimeDiscountDocs = response.data.items;
				this.oneTimeDiscountDocsTotal = response.data.total;
				this.loader = false
			}).catch(() => {
				this.loader = true;
			});
			// this.secondRefField = this.columns.filter((column => {
			// 	if (column.key !== 'discount' && column.visible) {
			// 		column.label = this.$t(column.label)
			// 		return column
			// 	}
			// }))
		},
		reloadList() {
			setTimeout(() => {
				this.getAllPromos();
			}, 200);
			this.addPromo = false;
		},
		reloadListTab() {
			setTimeout(() => {
				this.getOneTimeDiscountDocs();
			}, 200);
			this.addThirdPromo = false;
		},
		secondReloadList() {
			setTimeout(() => {
				this.buyXGetYPromos();
			}, 200);
			this.addSecondPromo = false;
		},
		reloadPromotionSimpleList() {
			setTimeout(() => {
				this.getAddPromotoion();
			}, 200);
			this.promotionAddModal = false;
		},

		filterColumns(columns = [], section) {
			return columns.filter(column => {
				if (column.visible) {
					column.label = this.$t(column.label);
					return column
				}
			})
		},
		remove(id) {
			PromoService.deletePromo(id).then(response => {
				this.reloadList();
			});
		},
		removeTab(id) {
			PromoService.deletePromoTab(id).then(response => {
				this.reloadListTab();
			});
		},

		removeBuyX(id) {
			if (id) {
				PromoService.deletePromo(id).then(response => {
					this.secondReloadList();
				});
			}
		},
		removePromotionSimple(id) {
			PromoService.promotionSimpleDelete(id).then(response => {
				this.reloadPromotionSimpleList();
			});
		},
		async openCreate(item = null, mode = 'create') {
			this.item = item;
			this.mode = await mode;
			if (mode == "edit") {
				let payload = {
					promotionId: item.id,
					page: this.search.page,
					limit: this.search.limit
				}
				await PromoService.getPromotionById(payload).then(response => {
					this.item = response.data.promo;
					this.totalForEdit = response.data.totalItems;
				});
				await this.$store.commit('promo/setPromotion', payload);
			}
			setTimeout(() => {
				this.addPromo = true
			}, 100);
		},

		async openCreateTab(item, mode) {
			this.oneTimeDiscountDoc = item;
			this.modeTab = mode;
			this.addThirdPromo = true
			await this.$store.commit('promo/setOneTimeDiscountDoc', item);
			this.isView = mode === 'view';
			setTimeout(() => {
				this.addThirdPromo = true
			}, 100);
		},
		async secondOpenCreate(item = null, mode = 'create') {
			this.secondItem = item;
			this.buyXgetYMode = mode;
			if (mode == "edit") {
				let payload = {
					promotionId: item.id,
					page: this.secondSearch.page,
					limit: this.secondSearch.limit,
					pageGet: this.search.page,
					limitGet: this.search.limit
				}
				await PromoService.getBuyXGetYPromotionById(payload).then(response => {
					this.secondItem = response.data.promo;
					this.secondItem.promoGet = response.data.promoGet;
					this.secondTotalForEdit = response.data.totalItems;
					this.secondTotalForEditGet = response.data.totalItemsGet;
				});
				await this.$store.commit('promo/setSecondPromotion', payload);


			}
			setTimeout(() => {
				this.addSecondPromo = true
			}, 100);
		},
		edit(item = null, mode = 'create') {
			this.item = PromoService.getPromo(item.id)

		},

		deletePopover(index) {
			const refName = `popover${index}`;
			this.$refs[refName].$emit('close')
		},

		closeOthers(id) {
			Object.keys(this.$refs).map(key => {
				if (key !== `popover${id}`) {
					const refName = key;
					this.$refs[refName].$emit('close')
				}
			});
		},
		onOpen(itemId) {
			let refName = 'popover' + itemId;
			this.$refs[refName].$emit('open')
		},

		// Close new promo modal
		close() {
			this.addPromo = false;
			this.mode = 'create';
			this.item = null;
			this.totalForEdit = 0
		},
		closePromotionSimple() {
			this.promotionAddModal = false;
			this.mode = 'create';
			this.item = null;
			this.totalForEdit = 0
		},
		closeTab() {
			this.addThirdPromo = false;
			this.modeTab = 'create';
			this.oneTimeDiscountDoc = null;
			this.thirdTotalForEdit = 0
		},
		buyXgetYClose() {
			this.buyXgetYMode = 'create'
			this.secondItem = null;
			this.addSecondPromo = false;
			this.secondTotalForEdit = 0;
			this.secondTotalForEditGet = 0;
		},
		onClose(itemId) {
			let refName = 'popover' + itemId;
			this.$refs[refName].$emit('close')
		},
		newPromo(item = null, mode = 'create') {
			this.item = item;
			this.mode = mode;
			setTimeout(() => {
				this.addPromo = true
			}, 100);
		},
		newPromoTab(item = null, mode = 'create') {
			this.oneTimeDiscountDoc = item;
			this.isView = mode === 'view';
			this.modeTab = mode;
			setTimeout(() => {
				this.addThirdPromo = true
			}, 100);
		},
		async secondNewPromo(item = null, mode = 'create') {
			this.secondItem = item;
			this.buyXgetYMode = await mode;
			setTimeout(() => {
				this.addSecondPromo = true
			}, 100);
		},
		promotionAdd(item = null, mode = 'create') {
			this.item = item;
			this.mode = mode;
			setTimeout(() => {
				this.promotionAddModal = true
			}, 100);
		},
	},
	beforeRouteLeave(to, from, next) {
		if (this.addPromo || this.addSecondPromo || this.addThirdPromo || this.promotionAddModal) {
			this.close()
			this.buyXgetYClose()
			this.closeTab()
			next(from.path)
		} else {
			next()
		}
	},
	watch: {
		'search.page': {
			handler() {
				this.getAllPromos()
				// this.getAllPromosTab()
			}
		},
		'thirdSearch.page': {
			handler() {
				this.getOneTimeDiscountDocs()
			}
		},

		'secondSearch.page': {
			handler() {
				this.buyXGetYPromos()
			}
		},
	},


	/**
	 * components
	 */
	components: {
		OneTimeDiscountTabs,
		NewPromoTabs,
		NewPromo,
		SecondNewPromo,
		BarcodeGenerate,
		PromotionSimple
	},
}
</script>

<style scoped>
a {
	color: black !important;
}

.tab-content .tab-pane {
	padding: 5px;
}

.table-wrapper {
	position: relative;
	padding: 8px;
}

.spinner-wrapper {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	text-align: center;
	background: rgba(0, 0, 0, 0.09);
	bottom: 0;
	z-index: 2;
	padding-top: 40px;
}
</style>
